import app from '../common_app.es6';

app.filter('percent', function () {
  return function(number, totalNumber) {
    if (totalNumber == undefined) return `${number || 0}%`;
    return totalNumber > 0 ? `${number || 0}%` : 'N/A'
  };
});
